import React from 'react'

const Loading = () => (
	<div className="d-flex w-100 vh-100 align-items-center justify-content-center">
        {/* <i class="fa-solid fa-circle-notch fa-spin"></i>
        <i class="fa-solid fa-spinner fa-spin"></i> */}
		<i className="fa-solid fa-circle-notch fa-spin fa-2x"></i>
	</div>
)

export default Loading;